// #region Imports
import { defineComponent, defineAsyncComponent } from "vue";
// #endregion
// #region Konstanten
// #endregion
// #region Core
export default defineComponent({
    name: 'g-color-edit',
    components: {
        DxColorBox: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dxCommon" */ /* webpackMode: "lazy" */ 'devextreme-vue/color-box')).DxColorBox;
        }),
    },
    props: {
        modelValue: {
            type: String,
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        formFieldName: {
            type: String,
            required: true,
            default: ''
        }
    },
    methods: {
        onChange(event) {
            this.$emit('update:modelValue', event.value);
        },
        restoreInheritance() {
            this.$emit('update:modelValue', null);
        },
    }
});
// #endregion
